<div class="toast-container position-fixed bottom-0 start-50 translate-middle-x p-3 z-3" aria-live="polite"
  aria-atomic="true">
  @for (toast of toasts(); track toast.id) {
  <div class="toast show mb-2 rounded-3 shadow-sm" [class.toast--exiting]="toast.isExiting" role="status"
    [class.text-bg-success]="toast.type === 'success'" [class.text-bg-danger]="toast.type === 'error'">
    <div class="d-flex align-items-center">
      <div class="toast-body d-flex flex-grow-1 align-items-center gap-2 px-3 py-2">
        <i class="bi fs-5 flex-shrink-0" [class.bi-check-circle-fill]="toast.type === 'success'"
          [class.bi-exclamation-triangle-fill]="toast.type === 'error'" aria-hidden="true"></i>
        <span class="fw-medium">{{ toast.message }}</span>
      </div>
      <button type="button" class="btn-close btn-close-white ms-auto me-3" aria-label="Close"
        (click)="dismiss(toast.id)"></button>
    </div>
  </div>
  }
</div>